import { Portal } from "primereact/portal";
import { Ripple } from "primereact/ripple";
import { Tooltip } from "primereact/tooltip";

if (Portal && Portal.defaultProps) {
  Portal.defaultProps = undefined;
}

if (Ripple && Ripple.defaultProps) {
  Ripple.defaultProps = undefined;
}

if (Tooltip && Tooltip.defaultProps) {
  Tooltip.defaultProps = undefined;
}
